import { defaultFixedIncomeExtraInfo, FixedIncomeExtraInfo } from "../../../AssetContext"

export function extraInfoGet(savedExtraInfo: any) {
    var newObject: FixedIncomeExtraInfo | any = defaultFixedIncomeExtraInfo
    if(!savedExtraInfo) return newObject
    const info = savedExtraInfo.fixed_income
    newObject = { ...info?.issuer_info, ...info?.bond_info, ...info?.legal_details, ...info?.security_package, ...info?.esg }
    return newObject
}

export function extraInfoPut(extraInfo: FixedIncomeExtraInfo) {
    var newObject = {}
    if(!extraInfo) return newObject
    newObject = {
        issuer_info: {
            issuer_legal_name: extraInfo.issuer_legal_name,
            lei: extraInfo.lei,
            jurisdiction: extraInfo.jurisdiction,
            sector: extraInfo.sector,
            credit_rating: extraInfo.credit_rating,
            description: extraInfo.description
        },
        bond_info: {
            bond_name: extraInfo.bond_name,
            isin: extraInfo.isin,
            currency: extraInfo.currency,
            nominal_value_per_token: extraInfo.nominal_value_per_token,
            total_issue_size: extraInfo.total_issue_size,
            use_of_proceeds: extraInfo.use_of_proceeds,
            coupon_rate: extraInfo.coupon_rate,
            coupon_type: extraInfo.coupon_type,
            payment_frequency: extraInfo.payment_frequency,
            issue_price: extraInfo.issue_price,
            yield_issue: extraInfo.yield_issue,
            settlement_date: extraInfo.settlement_date,
            issue_date: extraInfo.issue_date,
            maturity_date: extraInfo.maturity_date,
            redemption: extraInfo.redemption,
            rank: extraInfo.rank
        },
        legal_details: {
            governing_law: extraInfo.governing_law,
            prospectus: extraInfo.prospectus,
            tax_info: extraInfo.tax_info,
            subscription_term: extraInfo.subscription_term,
            settlement_system: extraInfo.settlement_system,
            transfer_restriction: extraInfo.transfer_restriction
        },
        security_package: {
            collateral_assets: extraInfo.collateral_assets,
            security_agent: extraInfo.security_agent,
            affirmative_covenants: extraInfo.affirmative_covenants,
            negative_covenants: extraInfo.negative_covenants,
            esg_covenants: extraInfo.esg_covenants,
            collateral_substitution: extraInfo.collateral_substitution,
            enforcement_mechanism: extraInfo.enforcement_mechanism,
        },
        esg: {
            green_bond_label: extraInfo.green_bond_label,
            second_party_opinion: extraInfo.second_party_opinion,
            certification_reference: extraInfo.certification_reference,
            impact_metrics: extraInfo.impact_metrics
        }
    }
    return newObject
}
